import { Doctor } from '../../types';

// Mock doctors database
export let mockDoctors: Doctor[] = [
  {
    id: 1,
    name: 'BS. Nguyễn Văn An',
    license_number: 'GP-001',
    phone: '0900000001',
    email: 'an@clinic.local',
    national_rx_user: 'rx001',
  },
  {
    id: 2,
    name: 'BS. Trần Thị Mai',
    license_number: 'GP-002',
    phone: '0900000002',
    email: 'mai@clinic.local',
    national_rx_user: 'rx002',
  },
];

